/* eslint-disable class-methods-use-this */
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums'
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend'
import {UIManagerEvents} from '../../../shared/scripts/ui_html/UIManagerEvents'
import {UIMManager} from './UIMManager'
import {UIUrlParameterNames} from '../../../shared/scripts/ui_html/UIUrlController'
import {EntryUrlParameterController} from '../EntryUrlParameterController'
import {UIMViewProfilePopup} from '../ui_popup/UIMViewProfilePopup'
import {getHomepageUrlWithParameter, navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils'

export class UIMManagerEvents extends UIManagerEvents {
    private readonly uiManager: UIMManager

    constructor(uiManager: UIMManager) {
        super()
        this.uiManager = uiManager
    }

    async createClickedJoinRoomCallback(gameId: string) {
        await SocketLobbySend.clickedJoinRoom(gameId)
    }

    isSceneLobby(): boolean {
        return this.uiManager.sceneController.scene != UIMSceneEnum.Lobby
    }

    leaveRoomAndJoinRoom(roomId: string) {
        void SocketLobbySend.clickedJoinRoom(roomId)
    }

    handleUrlRedirectViaParameters(parameter: UIUrlParameterNames, parameterValue: any) {
        if(parameter == UIUrlParameterNames.EnterMatchmaking) {
            EntryUrlParameterController.loadMatchmakingQueue(parameterValue)
            return
        }

        if(parameter == UIUrlParameterNames.Spectate) {
            navigateToPage(getHomepageUrlWithParameter(parameter, parameterValue))
            return
        }
    }

    openProfilePage(username: string) {
        new UIMViewProfilePopup(username)
    }

    premiumMembershipCheckAction() {
        return () => {
            navigateToPage('/store#membership', true, true)
        }
    }
}
